import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { isLogin, userGradeType } from '../../../utils/auth';
import { useModal } from '../../../context/ModalContext';

const algorithmSection = [
  {
    id: '추천1',
    category: '경기 ・ 아파트',
    description: '수도권 아파트로<br/>매매수익 보고싶다면?',
    img: '/assets/images/main/main_building_40.svg',
  },
  {
    id: '추천2',
    category: '경기 ・ 다세대/빌라',
    description: '수도권 단독주택으로<br/>월세 받을 수 있을까?',
    img: '/assets/images/main/main_home_40.svg',
  },
  {
    id: '추천3',
    category: '인천 ・ 대지',
    description: '아직도 건물만 보세요?<br/>알짜 수익은 땅에 있습니다!',
    img: '/assets/images/main/main_mountain_40.svg',
  },
];

interface AlgorithmSectionProps {
  page: string;
  selectedKey?: string | number | null;
  onSelect?: (key: string) => void;
}

const AlgorithmSection = ({
  page,
  selectedKey,
  onSelect,
}: AlgorithmSectionProps) => {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  const handleClick = async (id: string, page: string) => {
    if (onSelect) {
      onSelect(id);
    }
    if (page === 'main') {
      if (!isLogin()) {
        modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
        return;
      }
      const grade = await userGradeType();
      if (!grade) {
        modalDispatch({ type: 'USER_ALERT', payload: 'free' });
        return;
      }
      navigate('/AiRecommendation', { state: { selectedAlgorithmKey: id } });
    }
  };

  return (
    <>
      {algorithmSection.map((item) => (
        <AlgorithmDiv
          onClick={() => handleClick(item.id, page)}
          key={item.id}
          $active={selectedKey === item.id && page === 'airecommendation'}
        >
          <div>
            <Category>{item.category}</Category>
            <Description
              dangerouslySetInnerHTML={{ __html: item.description }}
            />
          </div>
          <Img src={item.img} />
        </AlgorithmDiv>
      ))}
    </>
  );
};

export default AlgorithmSection;

const AlgorithmDiv = styled.div<{ $active: boolean }>`
  padding: 24px;
  height: fit-content;
  flex: 0 0 auto;
  display: flex;
  align-items: end;
  justify-content: space-between;
  flex-direction: row;
  gap: 18px;
  background-color: #ffffff;
  box-shadow: 0px 4px 15px 0px rgba(141, 149, 163, 0.25);
  border-radius: 12px;
  pointer: cursor;
  border: ${({ $active }) =>
    $active ? '2px solid #008aff' : '2px solid transparent'};
`;
const Img = styled.img`
  width: 32px;
  height: 32px;
`;

const Category = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #616161;
`;

const Description = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #222222;
  line-height: 145%;
`;
